import { iso639_3Codes } from "../constants/iso-639-3-codes";

export function getLanguageLabel(code: string): string {
  const language = iso639_3Codes.find((lang) => lang.value === code);
  return language ? language.label : code;
}
